<ng-template #icon let-name>
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="1.8"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
  >
    <path *ngIf="name === 'OK'" d="M5 12l5 5L20 7" />
    <path *ngIf="name === 'NOT_APPLICABLE'" d="M6 12h12" />
    <ng-container *ngIf="name === 'DEVIATION'">
      <path d="M12 3l10 18H2L12 3z" />
      <path d="M12 10v5M12 18v.5" />
    </ng-container>
    <path *ngIf="name === 'comment'" d="M4 5h16v11H9l-5 4V5z" />
    <ng-container *ngIf="name === 'photo'">
      <path d="M4 8h3l2-3h6l2 3h3v11H4z" />
      <circle cx="12" cy="13" r="3.5" />
    </ng-container>
    <ng-container *ngIf="name === 'image'">
      <rect x="3" y="4" width="18" height="16" rx="2" />
      <circle cx="8.5" cy="9.5" r="1.5" />
      <path d="M21 16l-5-5L5 20" />
    </ng-container>
    <path
      *ngIf="name === 'expand'"
      d="M4 14v6h6M20 10V4h-6M4 20l6-6M20 4l-6 6"
    />
    <path *ngIf="name === 'plus'" d="M12 5v14M5 12h14" />
    <path *ngIf="name === 'close'" d="M6 6l12 12M18 6L6 18" />
    <path *ngIf="name === 'previous'" d="M15 6l-6 6 6 6" />
    <path *ngIf="name === 'next'" d="M9 6l6 6-6 6" />
    <ng-container *ngIf="name === 'search'">
      <circle cx="11" cy="11" r="7" />
      <path d="M20 20l-4-4" />
    </ng-container>
  </svg>
</ng-template>
<div class="checklist-progress" aria-live="polite">
  <progress
    [value]="answered"
    [max]="total || 1"
    [attr.aria-label]="'CHECKLIST_REDESIGN.PROGRESS' | translate"
  ></progress>
  <strong>{{
    "CHECKLIST_REDESIGN.ANSWERED"
      | translate: { answered: answered, total: total }
  }}</strong>
</div>
<div class="checklist-toolbar" *ngIf="longMode">
  <label class="checkpoint-search">
    <ng-container
      *ngTemplateOutlet="icon; context: { $implicit: 'search' }"
    ></ng-container>
    <input
      type="search"
      [(ngModel)]="searchQuery"
      [placeholder]="'CHECKLIST_REDESIGN.SEARCH' | translate"
      [attr.aria-label]="'CHECKLIST_REDESIGN.SEARCH' | translate"
    />
  </label>
  <div
    class="checklist-filters"
    role="group"
    [attr.aria-label]="'CHECKLIST_REDESIGN.FILTER' | translate"
  >
    <button
      type="button"
      [class.active]="filter === 'all'"
      [attr.aria-pressed]="filter === 'all'"
      (click)="filter = 'all'"
    >
      {{ "CHECKLIST_REDESIGN.ALL" | translate }}
    </button>
    <button
      type="button"
      [class.active]="filter === 'unanswered'"
      [attr.aria-pressed]="filter === 'unanswered'"
      (click)="filter = 'unanswered'"
    >
      {{ "CHECKLIST_REDESIGN.UNANSWERED" | translate }} ({{ total - answered }})
    </button>
    <button
      type="button"
      [class.active]="filter === 'deviations'"
      [attr.aria-pressed]="filter === 'deviations'"
      (click)="filter = 'deviations'"
    >
      {{ "DEVIATIONS" | translate }} ({{ deviations }})
    </button>
  </div>
</div>
<div class="checkpoint-layout" [class.section-mode]="longMode">
  <nav
    class="checkpoint-outline"
    *ngIf="sections.length"
    [attr.aria-label]="'CHECKLIST_REDESIGN.OUTLINE' | translate"
  >
    <button
      *ngFor="let section of sections; let s = index"
      type="button"
      [class.active]="activeSection === s"
      [class.complete]="
        section.Items?.length &&
        sectionAnswered(section) === section.Items.length
      "
      [attr.aria-current]="activeSection === s ? 'step' : null"
      (click)="selectSection(s)"
    >
      <span
        *ngIf="longMode"
        class="section-ring"
        [class.partial]="sectionAnswered(section) > 0"
        [class.done]="
          section.Items?.length &&
          sectionAnswered(section) === section.Items.length
        "
      >
        <ng-container
          *ngIf="
            section.Items?.length &&
            sectionAnswered(section) === section.Items.length
          "
          [ngTemplateOutlet]="icon"
          [ngTemplateOutletContext]="{ $implicit: 'OK' }"
        ></ng-container>
      </span>
      <span class="section-name">{{ s + 1 }}&nbsp; {{ section.Title }}</span>
      <span
        class="section-warning"
        *ngIf="sectionHasDeviation(section)"
        [attr.aria-label]="'DEVIATIONS' | translate"
        ><ng-container
          *ngTemplateOutlet="icon; context: { $implicit: 'DEVIATION' }"
        ></ng-container
      ></span>
      <small
        >{{ sectionAnswered(section) }} /
        {{ section.Items?.length || 0 }}</small
      >
      <span *ngIf="!longMode" class="section-progress"
        ><span
          [style.width.%]="
            section.Items?.length
              ? (sectionAnswered(section) / section.Items.length) * 100
              : 0
          "
        ></span
      ></span>
    </button>
  </nav>
  <div class="checkpoint-sections">
    <p class="checkpoint-error" role="alert" *ngIf="uploadError">
      {{ "CHECKLIST_REDESIGN.UPLOAD_ERROR" | translate }}
    </p>
    <ng-container *ngFor="let section of sections; let s = index">
      <section
        *ngIf="!longMode || activeSection === s"
        class="checkpoint-section"
        [attr.data-section]="s"
      >
        <header>
          <div>
            <small *ngIf="longMode">{{
              "CHECKLIST_REDESIGN.SECTION_PROGRESS"
                | translate
                  : {
                      section: s + 1,
                      total: sections.length,
                      answered: sectionAnswered(section),
                      count: section.Items?.length || 0
                    }
            }}</small>
            <h3>
              <span *ngIf="!longMode">{{ s + 1 }}</span
              >{{ section.Title }}
            </h3>
          </div>
          <button
            *ngIf="longMode"
            type="button"
            class="checklist-button"
            (click)="markRestNa(section)"
            [disabled]="sectionAnswered(section) === section.Items?.length"
          >
            {{ "CHECKLIST_REDESIGN.MARK_REST_NA" | translate }}
          </button>
        </header>
        <ng-container *ngFor="let item of section.Items; let i = index">
          <article
            *ngIf="visible(item)"
            class="checkpoint"
            [class.has-deviation]="isDeviation(item)"
            [class.is-answered]="isAnswered(item)"
          >
            <div class="checkpoint-main">
              <span class="compact-number" *ngIf="longMode"
                >{{ s + 1 }}.{{ i + 1 }}</span
              >
              <button
                class="reference-image"
                type="button"
                *ngIf="item.ReferenceImagePath"
                (click)="openImage(item.ReferenceImagePath, item.Title)"
                [attr.aria-label]="
                  ('CHECKLIST_REDESIGN.OPEN_IMAGE' | translate) +
                  ': ' +
                  item.Title
                "
              >
                <img
                  *ngIf="!failedImages.has(item.ReferenceImagePath)"
                  [previewImageSrc]="item.ReferenceImagePath"
                  [alt]="'CHECKLIST_REDESIGN.REFERENCE_IMAGE' | translate"
                  loading="lazy"
                  (error)="failedImages.add(item.ReferenceImagePath)"
                />
                <ng-container
                  *ngIf="failedImages.has(item.ReferenceImagePath)"
                  [ngTemplateOutlet]="icon"
                  [ngTemplateOutletContext]="{ $implicit: 'image' }"
                ></ng-container>
                <span class="reference-caption">{{
                  "CHECKLIST_REDESIGN.REFERENCE_IMAGE" | translate
                }}</span>
                <span class="reference-expand"
                  ><ng-container
                    *ngTemplateOutlet="icon; context: { $implicit: 'expand' }"
                  ></ng-container
                ></span>
              </button>
              <div class="checkpoint-body">
                <h4>
                  <span *ngIf="!longMode">{{ s + 1 }}.{{ i + 1 }}</span
                  >{{ item.Title }}
                </h4>
                <div class="checkpoint-controls">
                  <div
                    class="checkpoint-answers"
                    role="group"
                    [attr.aria-label]="item.Title"
                  >
                    <button
                      type="button"
                      *ngFor="let status of item.Status"
                      [disabled]="!canAnswer(item, status)"
                      [class.selected]="status.value"
                      [class.answer-ok]="statusKey(status) === 'OK'"
                      [class.answer-na]="statusKey(status) === 'NOT_APPLICABLE'"
                      [class.deviation]="statusKey(status) === 'DEVIATION'"
                      [attr.aria-pressed]="status.value"
                      (click)="answer(item, status)"
                    >
                      <ng-container
                        *ngTemplateOutlet="
                          icon;
                          context: { $implicit: statusKey(status) }
                        "
                      ></ng-container>
                      {{
                        (longMode && statusKey(status) === "NOT_APPLICABLE"
                          ? "CHECKLIST_REDESIGN.NA_SHORT"
                          : statusKey(status)
                        ) | translate
                      }}
                    </button>
                  </div>
                  <div class="checkpoint-tools">
                    <button
                      type="button"
                      (click)="toggle(item)"
                      [attr.aria-expanded]="expanded.has(item)"
                      [attr.aria-label]="
                        ('COMMENTS' | translate) +
                        ' (' +
                        (item.Comments ? 1 : 0) +
                        ')'
                      "
                    >
                      <ng-container
                        *ngTemplateOutlet="
                          icon;
                          context: { $implicit: 'comment' }
                        "
                      ></ng-container
                      ><span class="tool-label">{{
                        "COMMENTS" | translate
                      }}</span
                      ><span class="tool-count" *ngIf="item.Comments">1</span>
                    </button>
                    <button
                      type="button"
                      (click)="toggle(item)"
                      [attr.aria-expanded]="expanded.has(item)"
                      [attr.aria-label]="
                        ('FILES' | translate) +
                        ' (' +
                        (item.Attachments?.length || 0) +
                        ')'
                      "
                    >
                      <ng-container
                        *ngTemplateOutlet="
                          icon;
                          context: { $implicit: 'photo' }
                        "
                      ></ng-container
                      ><span class="tool-label">{{
                        "CHECKLIST_REDESIGN.PHOTOS" | translate
                      }}</span
                      ><span
                        class="tool-count"
                        *ngIf="item.Attachments?.length"
                        >{{ item.Attachments.length }}</span
                      >
                    </button>
                  </div>
                </div>
                <label class="checkpoint-score" *ngIf="scoreEnabled"
                  >{{ "SCORE" | translate }}
                  <select
                    [(ngModel)]="item.Score"
                    (ngModelChange)="changed.emit(item)"
                  >
                    <option [ngValue]="null">—</option>
                    <option
                      *ngFor="let score of [1, 2, 3, 4, 5, 6]"
                      [ngValue]="score"
                    >
                      {{ score }}
                    </option>
                  </select></label
                >
                <small class="checkpoint-signature" *ngIf="item.Signature">{{
                  item.Signature
                }}</small>
              </div>
            </div>
            <div
              class="checkpoint-details"
              *ngIf="expanded.has(item) || isDeviation(item)"
            >
              <div *ngIf="isDeviation(item)" class="deviation-notice">
                <ng-container
                  *ngTemplateOutlet="icon; context: { $implicit: 'DEVIATION' }"
                ></ng-container
                ><span>{{
                  "CHECKLIST_REDESIGN.DEVIATION_HELP" | translate
                }}</span>
              </div>
              <ng-container *ngFor="let status of item.Status"
                ><p *ngIf="status.value && status.DeviationNumber">
                  {{ "DEVIATIONNO" | translate }}: {{ status.DeviationNumber }}
                </p></ng-container
              >
              <label *ngIf="isDeviation(item) && references.length"
                >{{ "REFERENCE" | translate
                }}<select
                  class="form-control"
                  [(ngModel)]="item.ReferenceChecklist"
                  (ngModelChange)="changed.emit(item)"
                >
                  <option
                    *ngFor="let reference of references"
                    [ngValue]="reference.value"
                  >
                    {{ reference.label }}
                  </option>
                </select></label
              >
              <label
                >{{
                  (isDeviation(item)
                    ? "CHECKLIST_REDESIGN.DESCRIBE_DEVIATION"
                    : "COMMENTS"
                  ) | translate
                }}<textarea
                  class="form-control"
                  [(ngModel)]="item.Comments"
                  (ngModelChange)="changed.emit(item)"
                  rows="3"
                ></textarea>
              </label>
              <span class="photos-label">{{
                "CHECKLIST_REDESIGN.PHOTOS_FILES" | translate
              }}</span>
              <div class="checkpoint-photos">
                <figure *ngFor="let file of item.Attachments">
                  <button
                    *ngIf="isImage(file)"
                    type="button"
                    (click)="
                      openImage(
                        file.path,
                        file.OriginalFileName || file.filename,
                        file.mimetype
                      )
                    "
                  >
                    <img
                      *ngIf="!failedImages.has(file.path)"
                      [src]="file.path"
                      [alt]="file.OriginalFileName || file.filename"
                      loading="lazy"
                      (error)="failedImages.add(file.path)"
                    /><ng-container
                      *ngIf="failedImages.has(file.path)"
                      [ngTemplateOutlet]="icon"
                      [ngTemplateOutletContext]="{ $implicit: 'image' }"
                    ></ng-container>
                  </button>
                  <a
                    *ngIf="!isImage(file)"
                    [href]="file.path"
                    target="_blank"
                    rel="noopener noreferrer"
                    ><i class="pi pi-file" aria-hidden="true"></i
                    >{{ file.OriginalFileName || file.filename }}</a
                  >
                  <figcaption>
                    <span>{{ file.OriginalFileName || file.filename }}</span
                    ><button
                      type="button"
                      (click)="remove(item, file)"
                      [attr.aria-label]="'DELETE' | translate"
                    >
                      <ng-container
                        *ngTemplateOutlet="
                          icon;
                          context: { $implicit: 'close' }
                        "
                      ></ng-container>
                    </button>
                  </figcaption>
                </figure>
                <label
                  *ngIf="uploader"
                  class="checkpoint-upload"
                  [class.uploading]="uploading.has(item)"
                  ><ng-container
                    *ngTemplateOutlet="icon; context: { $implicit: 'plus' }"
                  ></ng-container
                  ><span>{{
                    (uploading.has(item) ? "PROCESSING" : "ADD_FILES")
                      | translate
                  }}</span
                  ><input
                    type="file"
                    multiple
                    [disabled]="uploading.has(item)"
                    (change)="upload($event, item)"
                /></label>
              </div>
            </div>
            <ng-container
              *ngTemplateOutlet="
                checkpointExtra;
                context: { $implicit: item, sectionIndex: s, itemIndex: i }
              "
            ></ng-container>
          </article>
        </ng-container>
        <div class="checkpoint-empty" *ngIf="!sectionHasVisibleItems(section)">
          <ng-container
            *ngTemplateOutlet="icon; context: { $implicit: 'OK' }"
          ></ng-container
          >{{ "CHECKLIST_REDESIGN.NO_MATCHES" | translate }}
        </div>
      </section>
    </ng-container>
    <div *ngIf="longMode && showSectionNavigation" class="checkpoint-section-nav">
      <button
        type="button"
        class="checklist-button"
        [disabled]="activeSection === 0"
        (click)="selectSection(activeSection - 1)"
      >
        <ng-container
          *ngTemplateOutlet="icon; context: { $implicit: 'previous' }"
        ></ng-container
        >{{ "CHECKLIST_REDESIGN.PREVIOUS_SECTION" | translate }}
      </button>
      <button
        type="button"
        class="checklist-button primary"
        [disabled]="activeSection >= sections.length - 1"
        (click)="selectSection(activeSection + 1)"
      >
        {{ "CHECKLIST_REDESIGN.NEXT_SECTION" | translate
        }}<ng-container
          *ngTemplateOutlet="icon; context: { $implicit: 'next' }"
        ></ng-container>
      </button>
    </div>
  </div>
</div>
<div class="checkpoint-remaining" *ngIf="showRemaining && answered < total">
  {{ "CHECKLIST_REDESIGN.REMAINING" | translate: { count: total - answered } }}
  <button type="button" (click)="firstUnanswered()">
    {{ "CHECKLIST_REDESIGN.FIRST_UNANSWERED" | translate }}
  </button>
</div>
<ecpl-image-viewer
  *ngIf="preview"
  [imgSrc]="preview.path"
  [imgName]="preview.name"
  [imgType]="preview.type"
  [isDialog]="true"
  (close)="preview = null"
></ecpl-image-viewer>
